import styled from 'styled-components';

export const TestExecutionNavigationButtonStyled = styled.button`
  border: none;
  background: none;
  color: var(--ds-text, var(--ds-fb-text));

  padding: 0;
  margin: 0;

  cursor: pointer;

  height: 100%;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
`;

export const NoPermissionTextStyled = styled.div`
  padding-right: 8px;

  :hover {
    text-decoration: underline;
  }
`;
